<div class="row m-3">
    <div class="col">
        <div class="card d-flex align-items-center justify-content-center">
            <img src="assets/images/dogcat.png" alt="Description" style="max-height:250px;float: left;padding-top: 50px;"> 
            <br> 
            <h3>No pets found for <b>{{clientService.client.first_name + ' ' + clientService.client.last_name}}</b>.</h3>
            <br> 

            {{'this client : ' + clientService.client.client_no}}
            <div>
                <button type="button" class="btn btn-primary font-weight-bold" (click)="add()">
                    <i class="fas fa-plus icon-sm"></i>Add New Pet
                </button>
                <button type="button" class="btn btn-danger font-weight-bold m-1" (click)="deleteClient()">
                    <i class="las la-trash"></i> Delete Client
                </button>
            </div>
            
            <br> 
            <br> 
            <br> 
            <br> 
        </div>
    </div>
</div>